/**
 * Google sign-in only works when a real OAuth client id is baked into the build
 * (REACT_APP_GOOGLE_CLIENT_ID, set per-service in Render). Until that exists, the button
 * renders but does nothing when clicked — which, on the signup screen, looks like a broken
 * product at exactly the wrong moment.
 *
 * So the button asks this first. The day the client id is configured and the frontend is
 * rebuilt, Google sign-in lights up on its own with no code change.
 */
export const GOOGLE_SIGN_IN_ENABLED = Boolean(
  (process.env.REACT_APP_GOOGLE_CLIENT_ID || "").trim(),
);

/** Shown on the disabled button so it reads as "not yet", not "broken". */
export const GOOGLE_SIGN_IN_DISABLED_HINT = "Google sign-in coming soon — use your email above";
